import { useQuery } from "@apollo/client";
import { GET_ALL_FINANCE_TREE_TRANSACTIONS } from "../graphql/queries/financeTransactions.graphql";

interface FinanceTransaction {
  id: number;
  transactionNumber: string;
  date: string;
  description: string;
  imageId?: number | null;
  totalDebit: number;
  totalCredit: number;
  total: number;
  isBalanced: boolean;
  createdAt: string;
  updatedAt: string;
}

interface FinanceTreeTransactionFilterDto {
  dateFrom?: string | null;
  dateTo?: string | null;
  description?: string | null;
}

interface GetAllFinanceTreeTransactionsVariables {
  limit: number;
  page: number;
  filter?: FinanceTreeTransactionFilterDto;
}

interface GetAllFinanceTreeTransactionsData {
  getAllFinanceTreeTransactions: {
    transactions: FinanceTransaction[];
  };
}

export const useFinanceTransactions = (
  limit: number,
  page: number,
  filter?: FinanceTreeTransactionFilterDto
) => {
  return useQuery<GetAllFinanceTreeTransactionsData, GetAllFinanceTreeTransactionsVariables>(
    GET_ALL_FINANCE_TREE_TRANSACTIONS,
    {
      variables: {
        limit,
        page,
        ...(filter && Object.keys(filter).length > 0 && { filter }),
      },
      fetchPolicy: "cache-and-network",
    }
  );
};

